
import React from 'react';
import { Link } from 'react-router-dom';
import theme from '../../../../assests/theme';
import { MuiGrid, MuiTypography, MuiSnackbar, MuiDivider, MuiButton, MuiPaper, MuiLockIcon, MuiInputAdornment, MuiTextField, muiWithStyles } from '../../../ui/MaterialUIComponents'
import routes from '../../../navigation/Routes'

import MaterialUIForm from 'material-ui-form'
import withAppShell from '../../../hoc/withAppShell/WithAppShell';

import { changePassword } from 'react-cognito'
import { SignUpActions } from '../../../../store';

class ChangePassword extends React.Component {

    constructor(props) {

        super(props);

        this.state = {

            error: "",
            newPassword: '',
            confirmPassword: '',
            oldPassword: '',
            snackBarOpenFlag: false,
            message: ''
        }
    }
    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
            error: ''
        });

    };

    handleClose = () => {

        this.setState({
            error: "",
            newPassword: '',
            confirmPassword: '',
            oldPassword: '',
            snackBarOpenFlag: false,
            message: ''
        })
    }
    componentDidMount() {


    }

    snackBarOpen = (toastMsg) => {
        this.setState({ snackBarOpenFlag: true, message: toastMsg });
    };

    snackBarClose = () => {
        this.setState({ snackBarOpenFlag: false });
    };



    validate = () => {
        if (this.state.newPassword === "") {
            this.setState({ error: "Please fill in new password field" });
        }
        if (this.state.newPassword.length < 8) {
            this.setState({ error: "Password should be of min length 8" });
        }
        if (this.state.newPassword === this.state.confirmPassword) {
            return true;
        }
        if (this.state.newPassword !== this.state.confirmPassword) {
            this.setState({ error: "Passwords do not match" });
            return false;
        }
    };


    onSubmit = async () => {

        if (this.validate()) {

            let success = false;

            await changePassword(this.props.user, this.state.oldPassword, this.state.newPassword

            ).then(() => {

                let message = SignUpActions.changePassword(this.props.userInformation.email)
                this.snackBarOpen("Change Password SuccessFul");
                success = true
                this.setState({
                    error: '',
                })
                this.props.user.signOut()
                window.location.href = '/'
            }

            )
                .catch((error) => {
                    if (error == 'Incorrect username or password.') {
                        this.snackBarOpen('Incorrect password.')
                    }
                    else {
                        this.snackBarOpen(error)

                    }

                }
                );

        }
    }



    render() {

        const { classes, i18n } = this.props;

        return (
            <MuiGrid container xs={12} >

                <MaterialUIForm className={classes.form} onSubmit={this.onSubmit}>
                    <MuiSnackbar
                        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                        open={this.state.snackBarOpenFlag}
                        onClose={this.snackBarClose}

                        ContentProps={{
                            'aria-describedby': 'message-id',
                        }}
                        message={<span id="message-id">{this.state.message}</span>}
                    />
                    <MuiGrid container xs={12} justify="center" >
                        <MuiGrid container xs={6} >

                            <MuiGrid item xs={12} >

                                <MuiTypography variant={theme.typographyStyles.H6} className={classes.titleStyle} > {i18n.changePassword.title}</MuiTypography>
                            </MuiGrid>

                            <MuiGrid container xs={12}  >


                                <MuiGrid item xs={12} >

                                    <MuiTextField id="oldPassword" label={i18n.changePassword.oldPasswordLabel}
                                        onChange={this.handleChange('oldPassword')} margin="normal"
                                        data-validators="isRequired,isAlpha"
                                        placeholder={i18n.changePassword.enterOldPassword}
                                        type="password"
                                        required
                                        className={classes.textFieldStyle}
                                        InputProps={{
                                            startAdornment: (
                                                <MuiInputAdornment position="end">
                                                    <MuiLockIcon color="primary" />
                                                </MuiInputAdornment>
                                            ),
                                        }}
                                    />
                                </MuiGrid>
                                <MuiGrid item xs={12}>
                                    <MuiTextField
                                        id="newPassword"
                                        label={i18n.changePassword.newPasswordLabel}
                                        onChange={this.handleChange('newPassword')}
                                        margin="normal"
                                        data-validators="isRequired,isAlpha"
                                        placeholder={i18n.changePassword.enterNewPassword}
                                        type="password"
                                        required
                                        className={classes.textFieldStyle}

                                        InputProps={{
                                            startAdornment: (
                                                <MuiInputAdornment position="end">
                                                    <MuiLockIcon color="primary" />
                                                </MuiInputAdornment>
                                            ),
                                        }}
                                    /></MuiGrid>
                                <MuiGrid item xs={12}>
                                    <MuiTextField id="confirmPassword"
                                        label={i18n.changePassword.confirmPasswordLabel}
                                        onChange={this.handleChange('confirmPassword')}
                                        margin="normal"
                                        data-validators="isRequired,isAlpha"
                                        placeholder={i18n.changePassword.enterNewPassword}
                                        type="password" required
                                        className={classes.textFieldStyle}
                                        InputProps={{
                                            startAdornment: (
                                                <MuiInputAdornment position="end">
                                                    <MuiLockIcon color="primary" />
                                                </MuiInputAdornment>
                                            ),
                                        }}

                                    />
                                    <br /></MuiGrid>

                                <MuiGrid container xs={12} justify='center' alignContent='center' spacing={1}>
                                    {this.state.error != '' && <MuiGrid xs={12}>
                                        <MuiTypography align="left" variant="caption" color="error">
                                            {this.state.error}
                                        </MuiTypography>  <br />
                                    </MuiGrid>}

                                    <MuiGrid xs={12}>
                                        <MuiTypography align="left" variant="caption" color="primary">{i18n.resetPassword.minmumPasswordLength}</MuiTypography>
                                        <br />
                                    </MuiGrid>

                                    <MuiGrid item  >
                                        <Link to={routes.main} className={classes.textDecorationNone}>
                                            <MuiButton
                                                style={theme.secondaryButtonStyle} >Cancel</MuiButton>
                                        </Link>

                                    </MuiGrid>

                                    <MuiGrid item >
                                        <MuiButton
                                            id="ChangePassword"
                                            style={theme.primaryButtonStyle}
                                            type="submit"
                                        >
                                            Submit
                </MuiButton></MuiGrid>



                                </MuiGrid>
                            </MuiGrid>
                        </MuiGrid>
                    </MuiGrid>
                </MaterialUIForm>
            </MuiGrid>

        );
    }
}


const styles = theme => ({

    form: {
        width: '100%',
        marginTop: '10vh'
    },
    titleStyle: { fontWeight: 600 },
    textFieldStyle: {
        width: '80%'
    },

    textDecorationNone: {
        textDecoration: 'none'
    },

});
export default withAppShell(muiWithStyles(styles)(ChangePassword));
